import Vue from "vue";
import Vuex from "vuex";

// global -------------------------------------------------------------------------
import global from "./modules/global";

// routing ---------------------------------------------------------------------
import routing from "./modules/routing";
// ANALYTICS -------------------------------------------------------------------
import analytics from "./modules/analytics";
// API -------------------------------------------------------------------------
import api from "./modules/api";
// current user -------------------------------------------------------------------------
import current_user from "./modules/current_user";

// livestreams ---------------------------------------------------------------------
import conferencing from './modules/conferencing'
//navigation (whereabouts, location, areas, spaces) ----------------------------
import navigation from "./modules/navigation"

// error handling - app status popups + alerts ---------------------------------
import popups from "./modules/popups"

// search ----------------------------------------------------------------------
import search from "./modules/search"
// chat - space/room chat in sidebar -------------------------------------
import chat from "./modules/chat"
// library/media
import content from "./modules/content"
// notifications - invites/broadcasts/pins -------------------------------------
import notifications from "./modules/notifications"
// admin - manageUsers/customise/areaInfo/etc -------------------------------------
import settings from "./modules/settings"

// guest
import guest from "./modules/guest"

// permissions
import permissions from "./modules/permissions"

// debug
import debug from "./modules/debug"

// create connection ------------ //
Vue.use(Vuex);

// collection of all modules --------------//
// allowing access from vue
export default new Vuex.Store({
  modules: {
    global,

    routing,
    analytics,
    api,
    current_user,
    guest,

    conferencing,
    navigation,

    // error handling popups ------
    popups,

    //sidebar modules
    search,
    chat,
    content,
    notifications,
    settings,
    permissions,
    debug
  },
});
